export const BEHAVIOR_TRACKING_COPIES = {
  missionsTitle: 'Principales misiones del reto',
  missionsEmpty: 'Este comportamiento aún no tiene misiones en el skillset',
  toolsTitle: 'Herramientas',
  toolsEmpty: 'Este comportamiento aún no tiene herramientas en el skillset',
  addToolLabel: 'Añadir otra herramienta',
  searchPlaceholder: 'Busca una herramienta',
  searchEmpty: 'No encontramos una herramienta que coincida',
  readOnlyHint: 'La valoración ya está cerrada, esta información es solo de consulta',
  otherTechnologiesGroup: 'Otras herramientas',
  unknownToolName: 'Herramienta no disponible',
  emptyMissions: 'No hay herramientas seleccionadas.',
  emptyTools: 'No hay herramientas seleccionadas.',
};

export const BEHAVIOR_TRACKING_SEARCH_PAGE_SIZE = 25;
